module.exports = __webpack_public_path__ + "img/fs_03.8a1e0aa5.jpg";